"use client";
import recordPhraseUsage from "@workspace/casino_pages/legacyLayer/phraseUsage/recordPhraseUsage";
import { configurePhraseUsage } from "@workspace/cms-phrases/src/client/recorder";
import useSiteInfo from "@workspace/nextjs_utils/src/siteInfo/useSiteInfo";
import type { FC } from "react";

// TEMPORARY translation-migration tool. Mounted high in the root layout so the
// client recorder's flush is wired before any translation renders. Configures
// once per language, only when tracking is enabled, so recorded entries carry
// the locale they were rendered in. Remove with src/phraseUsage.

let configuredLanguage: string | undefined;

const PhraseUsageInit: FC = () => {
  const { language } = useSiteInfo();
  if (configuredLanguage !== language) {
    configuredLanguage = language;
    configurePhraseUsage({
      flush: (entries) => recordPhraseUsage(entries),
      locale: language,
    });
  }
  return null;
};

export default PhraseUsageInit;
